import React, { useContext, useEffect, useState } from 'react'
import { LeaderCardCon, LeaderCardInner } from './leaderStyles'
import { TeamContext } from '../../../Context'
import { mapPlayerStat } from '../../../Utils'
import { ConvertStatValue } from '../../../Utils/formatting'
import { ProfileImage } from '../../PersonStatsCard'
import { hasChampSeriesStarted, STATS_YEAR } from '../../../Config/League/league.config'
import { createUrl } from '../../../Routing/urls'
import { logEvent } from '../../../Utils'
import { LeaderData } from '../../../Api'
import { ANALYTICS_TAGS } from '../../../Constants/analytics'
import { PlayerSortKeys } from '../../../Constants/player'

type TeamLeadersProps = {
  stat: PlayerSortKeys
}

export const LeaderCard: React.FC<React.PropsWithChildren<TeamLeadersProps>> = ({
  stat,
}) => {
  const { team, getStatLeader } = useContext(TeamContext)!
  const [leader, setLeader] = useState<LeaderData | null>(null)
  const [statValue, setStatValue] = useState<string | number>('')
  const [statUrl, setStatUrl] = useState<string>('')

  useEffect(() => {
    if (!team) return
    getLdr()
  }, [team?.statLeaders])
  const getLdr = () => {
    const ldr = getStatLeader(stat)
    if (!ldr) return
    const stVal = ConvertStatValue(ldr.statValue, ldr.statType)
    if (stVal) {
      setStatValue(stVal)
    }
    const lk = createUrl('player', {
      firstName: ldr.firstName,
      lastName: ldr.lastName,
      slugName: ldr.slug,
      tab: 'stats',
      year: STATS_YEAR,
    })
    setStatUrl(lk)
    setLeader(ldr)
    return
  }

  const log = (event: string) => {
    if (!leader) return
    logEvent(event, {
      leader: `${leader.firstName} ${leader.lastName}`,
      leaderId: leader.officialId,
      stat,
    })
  }

  if (!leader) {
    return (
      <LeaderCardCon>
        <LeaderCardInner>
          <div className="statTitleCon">
            <h3>{mapPlayerStat(stat)}</h3>
          </div>
          <div className="emptyCard">
            {`There are no leaders for ${mapPlayerStat(stat).toLowerCase()}.`}
          </div>
        </LeaderCardInner>
      </LeaderCardCon>
    )
  }

  return (
    <LeaderCardCon>
      <LeaderCardInner
        href={statUrl}
        onClick={() => log(ANALYTICS_TAGS.leader_click)}
        aria-label={`${leader.firstName} ${leader.lastName} ${mapPlayerStat(
          stat
        )} leader`}
      >
        <div className="statTitleCon">
          <h3>{mapPlayerStat(stat)}</h3>
        </div>
        <div className="innerInfo">
          <div className="profImgCon">
            <ProfileImage
              img={leader.profileUrl}
              alt={`${leader.firstName} ${leader.lastName} Profile`}
            />
          </div>
          <div className="name">
            {leader.firstName} {leader.lastName}
          </div>
          <div className="positionText">
            {hasChampSeriesStarted
              ? ''
              : `${leader.jerseyNum}${leader.position && ` | ${leader.position}`}`}
          </div>
          <div className="statNumber">{statValue}</div>
        </div>
      </LeaderCardInner>
    </LeaderCardCon>
  )
}
